import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';

import { TokenStorage } from '@/app/core/services';

import { AuthFacade } from '@/app/core/auth';

export const guestGuard: CanMatchFn = () => {
  const authFacade = inject(AuthFacade);
  const tokenStorage = inject(TokenStorage);

  if (tokenStorage.has()) {
    return authFacade.redirectForAuthed();
  }

  return true;
};
